const BASE_URL_HOME: Record<string, string> = {
  develop: 'https://develop-home.helixa.ai',
  staging: 'https://staging-home.helixa.ai',
  production: 'https://home.helixa.ai',
};

export const getBackgroundImageUrl = (
  apiEnv = process.env.REACT_APP_API_ENV
): string => {
  const baseUrl = BASE_URL_HOME[apiEnv || 'develop'] || BASE_URL_HOME.develop;

  return `${baseUrl}/background.png`;
};

export const BACKGROUND_IMAGE_URL = getBackgroundImageUrl();
